import { SOCKET_EVENTS, SOCKET_METHODS, SOCKET_TYPES } from '@/entities/SocketService';
import useSocket from '@/hooks/useSocket';
import { ISocketBlockInfo } from '@/types/socket';
import _ from 'lodash';
import { useEffect } from 'react';
import { useBlockInfoStore } from './store';

export function useBlockInfo(chainId: number | undefined): ISocketBlockInfo | undefined {
  const { blockInfo, setBlockInfo } = useBlockInfoStore();
  const { socket } = useSocket();
  useEffect(() => {
    if (!socket || !chainId) return;

    const param = {
      chainId: chainId,
      type: SOCKET_TYPES.COMMON,
    };
    const subscribeId = Date.now();
    socket.emit({
      id: subscribeId,
      method: SOCKET_METHODS.SUBSCRIBE,
      params: param,
    });

    socket.on(SOCKET_EVENTS.BLOCK_NUMBER_CHANGED, (data: ISocketBlockInfo) => {
      // console.record('socket', MESSAGE_TYPE.blockNumberChanged, data);
      setBlockInfo(data.chainId, data);
    });

    return () => {
      // Unsubscribe on cleanup to avoid ghost subscriptions on reconnect
      socket.emit({
        id: subscribeId,
        method: SOCKET_METHODS.UNSUBSCRIBE,
        params: param,
      });
      socket.off(SOCKET_EVENTS.BLOCK_NUMBER_CHANGED);
    };
  }, [socket, setBlockInfo, chainId]);

  return _.get(blockInfo, chainId || 0);
}
